var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "databases-and-servers/databases/redis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "databases-and-servers/databases/redis",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#5C0D06",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Redis_Logo",
    transform: "translate(13.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9003925,30.2807507 C41.4769084,31.5440165 28.9222034,36.7060004 26.2493765,38.0992768 C23.5765495,39.4930872 22.091705,39.4794721 19.9802998,38.4700875 C17.8688947,37.4607029 4.50849738,32.0640592 2.10183188,30.9137185 C0.898899575,30.3386816 0.266465791,29.853611 0.266465791,29.3952367 L0.266465791,24.8048192 C0.266465791,24.8048192 17.6598632,21.0182254 20.46804,20.0109765 C23.2759499,19.0034606 24.2500955,18.9671537 26.6396754,19.8425232 C29.0295223,20.7178927 43.3178807,23.2959481 45.6796965,24.160906 C45.6796965,24.160906 45.6786286,28.2606467 45.6786286,28.6861847 C45.6788956,29.1400207 45.1340255,29.6379054 43.9003925,30.2807507 Z",
    id: "Shape",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9003925,25.6889985 C41.4769084,26.9517304 28.9222034,32.1142481 26.2493765,33.5075246 C23.5765495,34.9013349 22.091705,34.8877199 19.9802998,33.8783352 C17.8686277,32.8694846 4.50849738,27.471773 2.10183188,26.3219662 C-0.304833618,25.1716255 -0.3552895,24.3798152 2.00892899,23.4542567 C4.37288051,22.5281644 17.6598632,17.3151908 20.468307,16.3076749 C23.2762169,15.3006929 24.2503625,15.2638521 26.6399424,16.1394886 C29.0297892,17.0148581 41.5094778,21.9822264 43.8710266,22.8471844 C46.2331094,23.7129432 46.3238766,24.4257327 43.9003925,25.6889985 Z",
    id: "Shape",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9003925,22.7951267 C41.4769084,24.0583925 28.9222034,29.2203763 26.2493765,30.6141867 C23.5765495,32.0074632 22.091705,31.9938481 19.9802998,30.9844635 C17.8686277,29.9756128 4.50849738,24.5784352 2.10183188,23.4280944 C0.898899575,22.8530575 0.266465791,22.3685209 0.266465791,21.9101466 L0.266465791,17.3191952 C0.266465791,17.3191952 17.6598632,13.5328683 20.46804,12.5253524 C23.2759499,11.5181035 24.2500955,11.4815297 26.6396754,12.3568992 C29.0295223,13.2322687 43.3178807,15.8097901 45.6796965,16.6750151 C45.6796965,16.6750151 45.6786286,20.7747557 45.6786286,21.2008276 C45.6788956,21.6543966 45.1340255,22.1522814 43.9003925,22.7951267 Z",
    id: "Shape",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9003925,18.2033745 C41.4769084,19.4666403 28.9222034,24.6286241 26.2493765,26.0224344 C23.5765495,27.4157109 22.091705,27.4020958 19.9802998,26.3927112 C17.8686277,25.3838605 4.50849738,19.9864159 2.10183188,18.8363422 C-0.304833618,17.6862684 -0.3552895,16.8944581 2.00892899,15.9683657 C4.37288051,15.0428073 17.6598632,9.82956673 20.468307,8.82231781 C23.2762169,7.8150689 24.2503625,7.77849506 26.6399424,8.65386458 C29.0297892,9.52923409 41.5094778,14.4963354 43.8710266,15.3615603 C46.2331094,16.2270523 46.3238766,16.9401087 43.9003925,18.2033745 Z",
    id: "Shape",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9003925,15.0318619 C41.4769084,16.2951276 28.9222034,21.4573784 26.2493765,22.8511888 C23.5765495,24.2444653 22.091705,24.2308502 19.9802998,23.2214656 C17.8686277,22.2126149 4.50849738,16.8151703 2.10183188,15.6650965 C0.898899575,15.0900596 0.266465791,14.605256 0.266465791,14.1471487 L0.266465791,9.55619729 C0.266465791,9.55619729 17.6598632,5.76987041 20.46804,4.7626215 C23.2759499,3.75510563 24.2500955,3.71879875 26.6396754,4.59416827 C29.0295223,5.46953778 43.3178807,8.04705918 45.6796965,8.91228412 C45.6796965,8.91228412 45.6786286,13.0120248 45.6786286,13.4378297 C45.6788956,13.8911318 45.1340255,14.3890165 43.9003925,15.0318619 Z",
    id: "Shape",
    fill: "#A41E11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9003925,10.4401096 C41.4769084,11.7033754 28.9222034,16.8656262 26.2493765,18.2591696 C23.5765495,19.652446 22.091705,19.638831 19.9802998,18.6297133 C17.8688947,17.6205957 4.50849738,12.223418 2.10183188,11.0733443 C-0.304833618,9.92327051 -0.3552895,9.13119324 2.00892899,8.20536785 C4.37288051,7.27954245 17.6598632,2.06683579 20.468307,1.05931992 C23.2762169,0.0518040422 24.2503625,0.0154971639 26.6399424,0.891133641 C29.0297892,1.76650316 41.5094778,6.73360446 43.8710266,7.59882941 C46.2331094,8.46378739 46.3238766,9.17711076 43.9003925,10.4401096 Z",
    id: "Shape",
    fill: "#D82C20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "28.9238052 6.01921324 24.9887803 6.42766562 24.1078046 8.5473466 22.6848953 6.18206027 18.1411963 5.77360789 21.531618 4.55092037 20.5144915 2.67417511 23.6886737 3.91555 26.6813215 2.93579821 25.8724256 4.87661442"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "23.8728777 16.3026026 16.5287437 13.2565623 27.0523992 11.6414401"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 13.690934,
    cy: 9.37759948,
    rx: 5.62462955,
    ry: 2.18028143
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#7A0C00",
    points: "33.5742892 6.59852152 39.8025206 9.0599143 33.5796284 11.5186375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#AD2115",
    points: "26.6839912 9.32420701 33.5742892 6.59852152 33.5796284 11.5186375 32.9042137 11.7829302"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/redis.2775ab7b178106a6381c153f6dcb92bd.svg";
export { ForwardRef as ReactComponent };